/**
 * Stato del supporto per piattaforma e-learning.
 *
 * Tenuto in un posto solo perché compare in più pagine (landing + guide): quando
 * San Raffaele passa da test a supportata, si cambia qui e si aggiorna in tutte.
 */
export const PLATFORMS = [
    {
        name: 'Pegaso',
        fullName: 'Università Telematica Pegaso',
        status: 'supported',
        label: 'Supportata',
        guidePath: '/guide/velocizzare-videolezioni-pegaso'
    },
    {
        name: 'Mercatorum',
        fullName: 'Università Telematica Universitas Mercatorum',
        status: 'supported',
        label: 'Supportata',
        guidePath: '/guide/velocizzare-videolezioni-mercatorum'
    },
    {
        name: 'San Raffaele',
        fullName: 'Università Telematica San Raffaele Roma',
        status: 'testing',
        label: 'In test — in arrivo',
        guidePath: null
    }
]

export const SUPPORTED_PLATFORMS = PLATFORMS.filter((p) => p.status === 'supported')
export const TESTING_PLATFORMS = PLATFORMS.filter((p) => p.status === 'testing')

/** Es. "Pegaso e Mercatorum" — usato nei testi e nelle description. */
export const SUPPORTED_NAMES = SUPPORTED_PLATFORMS.map((p) => p.name).join(' e ')
